import {
  CustomCaseProperty,
  CustomDocumentProperty,
  CustomPropertyType,
  KeyValue,
  KeyValueOptionalInput,
  Scalars,
} from "generated/graphql";
import { formatDateBackend, parseDate } from "../Backend";

export type CustomPropertyValue = string | Date | undefined;

export function serializeCustomPropertyValue(value: CustomPropertyValue): string | null | undefined {
  return value === undefined ? null : typeof value === "string" ? value : formatDateBackend(value);
}

export function deserializeCustomPropertyValue(
  value: string | undefined,
  customProperty: {
    dataType: CustomPropertyType;
  }
): CustomPropertyValue {
  if (customProperty.dataType === CustomPropertyType.Date) {
    return parseDate(value);
  } else {
    return value;
  }
}

export function customPropertiesToUI(
  properties: (CustomCaseProperty | CustomDocumentProperty)[],
  propertyValues: KeyValue[]
): Record<string, CustomPropertyValue> {
  return properties.reduce((prev, dp) => {
    const foundValue = propertyValues.find((p) => p.key === dp.key)?.value;
    prev[dp.key] = deserializeCustomPropertyValue(foundValue, dp);

    return prev;
  }, {});
}

export function customPropertiesFromUI(propertyValues: Record<string, CustomPropertyValue>): KeyValueOptionalInput[] {
  return Object.entries(propertyValues).map(([key, value]) => {
    // We are able to infer the target type from the value alone here, so we don't need the actual properties.
    // But if we ever add richer types we may need to pass the actual properties into this function
    // to inform the serialization more precisely
    const serializedValue = serializeCustomPropertyValue(value);
    return { key, value: serializedValue };
  });
}

export interface CustomPropertySchema {
  dataType: CustomPropertyType;
  displayName: Scalars["String"];
  selectOptions: Array<Scalars["String"]>;
}
